<template lang='pug'>
  .campaign-list(v-loading="loading")
    el-breadcrumb(
      separator="/"
      style="padding-bottom: 20px"
    )
      el-breadcrumb-item {{ $t('项目列表') }}
    el-card
      .campaign-list__header
        .title {{ $t('项目列表') }}
        .campaign-list__header__filter
          el-input(
            :placeholder="$t('搜索项目名称/ID/明星/品牌')"
            style="width: 200px"
            v-model="currentKeyword"
            @keyup.enter.native="handleSearch"
          )
            i(
              v-show="currentKeyword !== ''"
              slot="suffix"
              class="el-input__icon el-icon-circle-close"
              style="cursor: pointer"
              @click="handleClearInput"
            )
            i(
              slot="suffix"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
              @click="handleSearch"
            )
      el-table.campaign-list__table(
        :data='campaignList'
        :row-class-name="tableRowClassName"
      )
        el-table-column(
          prop='campaign_id'
          :label='$t("项目ID")'
          align='left'
          min-width="95"
        )
        el-table-column(
          prop='campaign_name'
          :label='$t("项目名称")'
          align='left',
          min-width="130"
          show-overflow-tooltip
        )
        el-table-column(
          prop='brand_name'
          :label='$t("品牌")'
          align='left'
          min-width="120"
          show-tooltip-when-overflow
        )
        el-table-column(
          prop='star_name'
          :label='$t("明星")'
          align='left'
          max-width="120"
          show-tooltip-when-overflow
        )
        el-table-column(
          prop='budget',
          :label='$t("预算")'
          align='left'
          min-width="110"
          show-tooltip-when-overflow
          :formatter="(row) => '￥' + numberWithCommas(row.budget, 2)"
        )
        el-table-column(
          :label='$t("进度")'
          align='left',
          :min-width="isEn && '165'"
        )
          template(slot-scope="scope")
              span {{ getStatus(scope.row.status) }}
        el-table-column(
          :label='$t("操作")'
          align='left'
          min-width="100"
        )
          template(slot-scope='scope')
            .campaign-list__operation
              el-button(
                type="text"
                @click='handleView(scope.row)'
              ) {{ $t('查看') }}
      el-pagination.campaign-list__pagination(
        layout='prev, pager, next, jumper'
        :page-size='10'
        :total='total'
        :current-page.sync='currentPage'
        @current-change='fetchCampaignList'
      )
</template>

<script>
import axios from 'axios'
import { numberWithCommas, formatDate } from '@/umcc/util'
import db from '@/umcc/db'

export default {
  data () {
    return {
      campaignList: null,
      loading: false,
      currentPage: 1,
      total: null,
      currentKeyword: ''
    }
  },
  computed: {
    isEn () {
      return db.lang === 'en'
    },
    keyword () {
      return this.$store.state.unistar.campaignListKeyword
    },
    pageNumber () {
      return this.$store.state.unistar.campaignListPageNumber
    }
  },
  watch: {
    $route () {
      this.$store.commit('unistar/setCampaignListPageNumber', 1)
      this.$store.commit('unistar/setCampaignListKeyword', '')
      this.currentKeyword = ''
      this.currentPage = 1
      this.fetchCampaignList()
    }
  },
  mounted () {
    this.currentKeyword = this.keyword
    this.currentPage = this.pageNumber
    this.fetchCampaignList()
  },
  filters: {
    numberWithCommas,
    formatDate
  },
  methods: {
    numberWithCommas,
    tableRowClassName ({row}) {
      return row.status === 2 ? 'disabled-row' : ''
    },
    getStatus (status) {
      switch (status) {
        case 0:
          return this.$t('草稿')
        case 1:
          return this.$t('进行中')
        case 2:
          return this.$t('已失效')
        case 3:
          return this.$t('已完成')
        case 4:
          return this.$t('已终止')
      }
    },
    fetchCampaignList () {
      this.loading = true
      this.$store.commit('unistar/setCampaignListPageNumber', this.currentPage)
      this.$store.commit('unistar/setCampaignListKeyword', this.currentKeyword)
      axios.get('/management/star/getCampaignList', {
        params: {
          page_size: 10,
          page_number: this.pageNumber,
          keyword: this.keyword
        }
      })
        .then(res => {
          this.loading = false
          this.campaignList = res.table_data
          this.total = res.total_row
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.fetchCampaignList()
    },
    handleClearInput () {
      this.currentKeyword = ''
      if (this.keyword !== '') {
        this.handleSearch()
      }
    },
    handleView (row) {
      this.loading = true
      this.$store.commit('unistar/setCampaignInfo', row)
      this.$router.push('/unistar/campaign-overview')
    }
  }
}
</script>

<style lang="stylus">
.campaign-list
  .el-table
    // tr
    //   th
    //     background-color #fafafa
    //     color #2c3031
    //     font-weight 500
    .disabled-row
      color $disabled
      td
        &:nth-child(2)
          text-decoration line-through
  .campaign-list__header
    display flex
    justify-content space-between
    align-items center
    .title
      font-size 18px
      color #2c3031
      font-weight 500
    .el-button
      display flex
      justify-content space-around
      > span
        display flex
        align-items center
    .el-input
      width 180px
  .campaign-list__header__filter
    display flex
    align-items center
    .iconfont
      color $main
      margin-right 24px
  .campaign-list__pagination
    margin-top 20px
    float right
    .btn-next,.btn-prev
      background none !important
    .el-pager li
      background none
  .campaign-list__table
    margin-top 20px
  .addNewProject__btn
    background #4896e6
    box-shadow: 0 0 15px 0 rgba(72, 150, 230, 0.41)
    color #ffffff
    font-weight normal
    width 198px
    height 35px
    font-size 14px
    margin-bottom 24px
    &.el-button--default
      border none
    &:hover
      background #4896e6 !important
      color #ffffff !important
      border-color #4896e6 !important
</style>
